import { takeLatest, put, select } from 'redux-saga/effects'

import { productDetailPath,productPath } from '../routes'
import { createReducer, makeAction, makeKeys } from './reduxHelpers'
import { httpGet, customHeader,httpPost,httpPut } from '../core/restClient'
import { appLoading, appLoaded, showModal, toastSuccess,toastError } from './app'
import b64toBlob from 'b64-to-blob'
import Axios from 'axios'
import r from 'reactotron-react-js'
import { currencyNumberFormat, discountCalculator } from 'core/utilities'

import {
  productJson,
  productsJson,
  cateJson,
  subCateJson,
  brandndameJson,
  unitJson,
  productsSpecialField} from '../routes/Product/mj'
import { withholdingTaxList } from 'routes/ProcurementSystem/GoodsServiceReceipt/AttributeData'

const FETCH_PRODUCTS = makeKeys('FETCH_PRODUCTS')
const FETCH_PRODUCT = makeKeys('FETCH_PRODUCT')
const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS'
const SET_PRODUCTS_PAGINATE = 'SET_PRODUCTS_PAGINATE'
const ADD_PRODUCT_WISHLIST = 'ADD_PRODUCT_WISHLIST'
const REMOVE_PRODUCT_WISHLIST = 'REMOVE_PRODUCT_WISHLIST'

const FETCH_DATA_LISTVIEW_PROCESS = makeKeys('FETCH_DATA_LISTVIEW_PROCESS')
const FETCH_PRODUCTS_F_EXPORT = makeKeys('FETCH_PRODUCTS_F_EXPORT')
const ADD_PRODUCTS_EXPORT = 'ADD_PRODUCTS_EXPORT'
const DEL_PRODUCTS_EXPORT = 'DEL_PRODUCTS_EXPORT'
const FETCH_PRODUCT_CATEGORY = makeKeys('FETCH_PRODUCT_CATEGORY')
const FETCH_PRODUCT_SUBCATEGORY = makeKeys('FETCH_PRODUCT_SUBCATEGORY')
const FETCH_PRODUCT_BRANDNAME = makeKeys('FETCH_PRODUCT_BRANDNAME')
const FETCH_PRODUCT_UNIT = makeKeys('FETCH_PRODUCT_UNIT')
const GET_PRODUCT = makeKeys('GET_PRODUCT')
const SET_EXCEL_DATA = makeKeys('SET_EXCEL_DATA')
const DOWNLOAD_PD_SIGNED = makeKeys('DOWNLOAD_PD_SIGNED')
const CREATE_PRODUCT = makeKeys('CREATE_PRODUCT')
const EDIT_PRODUCT = makeKeys('EDIT_PRODUCT')
const FETCH_PRODUCT_SPECIALFIELD = makeKeys('FETCH_PRODUCT_SPECIALFIELD')
const PD_DOWNLOAD_FILE = 'PD_DOWNLOAD_FILE'
const PD_CHANGE_FILTER_CATEGORY_ID = 'PD_CHANGE_FILTER_CATEGORY_ID'
const PD_CHANGE_FILTER_SUBCATEGORY_ID = 'PD_CHANGE_FILTER_SUBCATEGORY_ID'
const PD_CHANGE_LIST_SIZE = 'PD_CHANGE_LIST_SIZE'
const PD_SHOW_TABLE = 'PD_SHOW_TABLE'
const PD_SEARCH = 'PD_SEARCH'
const FETCH_PRODUCTS_LIST_IMG = 'FETCH_PRODUCTS_LIST_IMG'
const FETCH_PRODUCTS_TABLE = 'FETCH_PRODUCTS_TABLE'
const CHANGE_PRODUCTS_TO_LIST_IMG = 'CHANGE_PRODUCTS_TO_LIST_IMG'
const CHANGE_PRODUCTS_TO_TABLE = 'CHANGE_PRODUCTS_TO_TABLE'
const CHANGE_EDIT_PRODUCT_STATUS = 'CHANGE_EDIT_PRODUCT_STATUS'
const CLEAR_PRODUCTS_EXPORT = 'CLEAR_PRODUCTS_EXPORT'
const IMPORT_PRODUCTS_EXCEL = makeKeys('IMPORT_PRODUCTS_EXCEL')

export const fetchProducts = makeAction(FETCH_PRODUCTS.REQUEST, 'query')
export const fetchProduct = makeAction(FETCH_PRODUCT.REQUEST, 'id')
export const fetchDataListViewProcess = makeAction(FETCH_DATA_LISTVIEW_PROCESS.REQUEST, 'searchKey', 'page', 'perPage')
export const clearProducts = makeAction(CLEAR_PRODUCTS)
export const setProductsPaginate = makeAction(SET_PRODUCTS_PAGINATE, 'page', 'size', 'totalItem', 'totalPage')
export const addProductWishlist = makeAction(ADD_PRODUCT_WISHLIST, 'product')
export const removeProductWishlist = makeAction(REMOVE_PRODUCT_WISHLIST, 'productId')

export const fetchProductsForExport = makeAction(FETCH_PRODUCTS_F_EXPORT.REQUEST, 'page', 'perPage')
export const addProductsExport = makeAction(ADD_PRODUCTS_EXPORT, 'product')
export const delProductsExport = makeAction(DEL_PRODUCTS_EXPORT, 'product')
export const clearProductsExport = makeAction(CLEAR_PRODUCTS_EXPORT)
export const fetchProductCategory = makeAction(FETCH_PRODUCT_CATEGORY.REQUEST)
export const fetchProductSubCategory = makeAction(FETCH_PRODUCT_SUBCATEGORY.REQUEST,'cateID')
export const fetchProductBrandname = makeAction(FETCH_PRODUCT_BRANDNAME.REQUEST)
export const fetchProductUnit = makeAction(FETCH_PRODUCT_UNIT.REQUEST)
export const fetchProductSpecialField = makeAction(FETCH_PRODUCT_SPECIALFIELD.REQUEST,'subCateID')
export const getProduct = makeAction(GET_PRODUCT.REQUEST, 'id')
export const downloadPdFile = makeAction(PD_DOWNLOAD_FILE, 'filename')
export const downloadPdSigned = makeAction(DOWNLOAD_PD_SIGNED.REQUEST, 'filename')
export const changeFilterCategoryID = makeAction(PD_CHANGE_FILTER_CATEGORY_ID, 'categoryID')
export const changeFilterSubCategoryID = makeAction(PD_CHANGE_FILTER_SUBCATEGORY_ID, 'subCategoryID')
export const changeListSize = makeAction(PD_CHANGE_LIST_SIZE, 'size')
export const changeTableType = makeAction(PD_SHOW_TABLE, 'showTable')
export const changeSearchKey = makeAction(PD_SEARCH, 'searchKey')
export const setExcelData = makeAction(SET_EXCEL_DATA, 'data')
export const importProductExcel = makeAction(IMPORT_PRODUCTS_EXCEL.REQUEST, 'data','history')
export const changeEditedProductStatus = makeAction(CHANGE_EDIT_PRODUCT_STATUS, 'isEdit')
export const createProduct = makeAction(CREATE_PRODUCT.REQUEST, 'data','history','cateName','subCateName','unitName')
export const editProduct = makeAction(EDIT_PRODUCT.REQUEST, 'data','history','cateName','subCateName','unitName')

const fetchProductsSuccess = makeAction(FETCH_PRODUCTS.SUCCESS, 'data')
const fetchProductSuccess = makeAction(FETCH_PRODUCT.SUCCESS, 'data')
const fetchDataListViewProcessSuccess = makeAction(FETCH_DATA_LISTVIEW_PROCESS.SUCCESS, 'data')
const fetchProductsForExportSuccess = makeAction(FETCH_PRODUCTS_F_EXPORT.SUCCESS, 'data')
const setProductsListImg = makeAction(FETCH_PRODUCTS_LIST_IMG, 'data')
const setProductsTable = makeAction(FETCH_PRODUCTS_TABLE, 'data')
const changeProductsToListImg = makeAction(CHANGE_PRODUCTS_TO_LIST_IMG)
const changeProductsToTable = makeAction(CHANGE_PRODUCTS_TO_TABLE)
const fetchProductCategorySuccess = makeAction(FETCH_PRODUCT_CATEGORY.SUCCESS, 'data','dataFilter')
const fetchProductSubCategorySuccess = makeAction(FETCH_PRODUCT_SUBCATEGORY.SUCCESS, 'data','dataFilter')
const fetchProductBrandnameSuccess = makeAction(FETCH_PRODUCT_BRANDNAME.SUCCESS, 'data')
const fetchProductUnitSuccess = makeAction(FETCH_PRODUCT_UNIT.SUCCESS, 'data')
const fetchProductSpecialFieldSuccess = makeAction(FETCH_PRODUCT_SPECIALFIELD.SUCCESS, 'data')
const getProductSuccess = makeAction(GET_PRODUCT.SUCCESS, 'data')
const createProductSuccess = makeAction(CREATE_PRODUCT.SUCCESS, 'data')
const editProductSuccess = makeAction(EDIT_PRODUCT.SUCCESS, 'data')
const importProductExcelSuccess = makeAction(IMPORT_PRODUCTS_EXCEL.SUCCESS)

const initial = {
  products: [],
  productsExport:[],
  productsExportTo:[],
  productsListImg: [],
  productsTable: [],
  productCategory: [],
  productSubCategory: [],
  filterCategoryOption: [{text: 'Category: All', value: 0}],
  filterSubCategoryOption: [{text: 'SubCategory: All', value: 0}],
  productBrandnameList: [],
  productUnit:[],
  product: {
    segmentIds: [],
    mqdcProjectIds: [],
    segments: [],
    mqdcProjects: [],
    attachments: [],
    links: [],
  },
  paginate: {},
  wishlist: [],
  productBrands: [],
  productSpecialField:[],
  filterCategoryID: 0,
  filterSubCategoryID: 0,
  listSize: 30,
  showTable: false,
  paging: {},
  loading: false,
  filePoSize: 0.0,
  searchKey: '',
  isEditedProduct:false,
  excelData:[],
  // AttOtherFile
  AttOtherU:[],
  AttOtherUrl:[],
  // AttIMG
  AttImgU:[],
  AttImgUrl:[],
  // AttVDO
  AttVDOUrl:[],
}

const convertProductToWishlist = (product) => {
  const wishlist = {
    'id': product.id,
    'name': product.productName,
    'image': product.coverImageUrl,
    'Status': product.status,
    'Product Code': product.productCode,
    'Product Name': product.productName,
    'Brand': product.brand,
    'Model': product.productModel,
    'Vendor': product.vendorCode ? `${product.vendorCode} | ${product.vendorNameEn}` : product.vendorNameEn,
    'Material': product.material,
    'Size': product.size,
    'Color': product.color,
    'Price List': currencyNumberFormat(product.price, product.currencyCode),
    'Discount': product.discountType === 'percent' ? `${product.discount} %`: currencyNumberFormat(product.discount, product.currencyCode),
    'Price After Discount': currencyNumberFormat(discountCalculator(product.price, product.discount, product.discountType), product.currencyCode),
    'Gross Weight': `${product.grossWeight || ''} ${product.weightUnit || ''}`,
    'Net Weight': `${product.netWeight || ''} ${product.weightUnit || ''}`,
    'Unit': product.unitCode,
    'Minimum Order': product.minimumOrder,
    'Delivery Time': product.deliveryTime,
  }

  return wishlist;
}

const setUpProducts = (productsJson)=>{
  let res = []
  let row = []
  let rowCount = 0
  productsJson.map((item,i)=>{
    if(rowCount<=5){
      row.push(item)
      rowCount++
      if(rowCount===6){
        res.push(row)
        row = []
        rowCount = 0
      }
    }
    if(productsJson.length===i+1){
      res.push(row)
    }
  })
  return res
}

const searchProduct = (products,searchKey = '')=>{
  if(searchKey.trim().length>0){
    let productsSearch = products.filter(function(value){
      return value.name.toLowerCase().includes(searchKey.toLowerCase())
      ||value.brandname.toLowerCase().includes(searchKey.toLowerCase())
      ||value.description.toLowerCase().includes(searchKey.toLowerCase())
      ||value.remark.toLowerCase().includes(searchKey.toLowerCase())
      ||value.no.toLowerCase().includes(searchKey.toLowerCase())
      ||value.categoryName.toLowerCase().includes(searchKey.toLowerCase())
      ||value.subCategoryName.toLowerCase().includes(searchKey.toLowerCase())
      ||value.unitName.toLowerCase().includes(searchKey.toLowerCase())
      ||value.planDeliveryTime.toLowerCase().includes(searchKey.toLowerCase())
    });
    return productsSearch
  }else{
    return products
  }
}

function* fetchProductsRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading())

    const response = yield httpGet('products', query)

    if (response.status === 200) {
      // let products = searchProduct(response.data)
      let productsTableData = setUpProducts(response.data.data)

      // yield put(setProductsListImg(JSON.parse(JSON.stringify(listImg))))
      // yield put(setProductsTable(JSON.parse(JSON.stringify(dataSearch))))
      yield put(setProductsPaginate(response.data.page, response.data.size, response.data.totalItem, response.data.totalPage))
      yield put(fetchProductsSuccess(productsTableData))
    }

    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* fetchProductRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading())

    const response = yield httpGet(`products/${id}`)

    if (response.status === 200) {
      yield put(fetchProductSuccess(response.data))
    }

    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* fetchDataListViewProcessRequest(action) {
  const { searchKey,page, perPage } = action.payload
  try {
    yield put(appLoading())
    const productsResp = yield httpGet('products/getlist')
    const cateResp = yield httpGet('products/getCategories')
    let cateData = setUpCategoryData(cateResp)
    const subCateResp = yield httpGet(`products/getSubCategories/0`)
    let subCateData = setUpSubCategoryData(subCateResp)
    const unitResp = yield httpGet('products/getUnits')
    let unitData = setUpUnitData(unitResp)

    if (productsResp.status === 200) {
      let dataSearch = searchProduct(productsResp.data,searchKey)
      let listImg = setUpProducts(dataSearch)
      yield put(fetchDataListViewProcessSuccess({
        products:listImg,
        listImg:JSON.parse(JSON.stringify(listImg)),
        listTable:JSON.parse(JSON.stringify(dataSearch)),
        cateData: cateData||[],
        subCateData:subCateData||[],
        unitData:unitData||[]
      }))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* fetchProductCategoryRequest(action) {
  try {
    yield put(appLoading())
    const response = yield httpGet('products/getCategories')
    let cateData = setUpCategoryData(response)
    if (cateData) {
      yield put(fetchProductCategorySuccess(cateData.resStr,cateData.resStrFilter))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function setUpCategoryData(response){
  if (response.status >= 200 && response.status < 300) {
    let resStr = []
    resStr.push({text: 'Other', value: 0})
    response.data.map((item,i)=>{
      resStr.push({text: item.name, value:item.id})
    })
    let resStrFilter = []
    resStrFilter.push({text: 'Category: All', value: 0})
    response.data.map((item,i)=>{
      resStrFilter.push({text: `Category: ${item.name}`, value:item.id})
    })
    return {resStr:resStr,resStrFilter:resStrFilter}
  }
  return null
}

function* fetchProductSubCategoryRequest(action) {
  const { cateID } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`products/getSubCategories/0`)
    let subCateData = setUpSubCategoryData(response)
    if (subCateData) {
      yield put(fetchProductSubCategorySuccess(subCateData.resStr,subCateData.resStrFilter))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function setUpSubCategoryData(response){
  if (response.status >= 200 && response.status < 300) {
    let resStr = []
    resStr.push({text: 'Other', value: 0})
    response.data.map((item,i)=>{
      resStr.push({text: item.name, value: item.id})
    })
    let resStrFilter = []
    resStrFilter.push({text: 'SubCategory: All', value: 0})
    response.data.map((item,i)=>{
      resStrFilter.push({text: `SubCategory: ${item.name}`, value: item.id})
    })
    return {resStr:resStr,resStrFilter:resStrFilter}
  }
  return null
}

function* fetchProductUnitRequest(action) {
  try {
    yield put(appLoading())
    const response = yield httpGet('products/getUnits')
    let unitData = setUpUnitData(response)
    if (unitData) {
      yield put(fetchProductUnitSuccess(unitData))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function setUpUnitData(response){
  if (response.status >= 200 && response.status < 300) {
    let resStr = []
    response.data.map((item,i)=>{
      resStr.push({text: `${item.name} (${item.code})`, value: item.id})
    })
    return resStr
  }
  return null
}

function* fetchProductsForExportRequest(action) {
  const { page, perPage } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('products/getlist')
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchProductsForExportSuccess(response.data))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* fetchProductBrandnameRequest(action) {
  try {
    yield put(appLoading())
    yield put(fetchProductBrandnameSuccess(brandndameJson))
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}


function* fetchProductOnTableTypeChange(action) {
  const { showTable } = action.payload
  try {
    yield put(appLoading())
    yield put(showTable?changeProductsToTable():changeProductsToListImg())
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* getProductRequest(action) {
  const { id }  = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`products/item/${id}`)
    if (response.status >= 200 && response.status < 300) {
      if(response.data){
        r.log(response.data)
        response.data.specialField = response.data.specialField?JSON.parse(response.data.specialField):{}
        yield put(getProductSuccess(response.data))
      }else{
        yield put(getProductSuccess(null))
      }
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes (CODE:gpr)'))
    yield put(appLoaded())
  }
}

function* fetchProductSpecialFieldRequest(action) {
  const { subCateID } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`products/geProductSpecialFieldBySubCatID/${subCateID}`)
    if (response.status >= 200 && response.status < 300&&response.data) {
      yield put(fetchProductSpecialFieldSuccess(response.data))
    }else if(response.status >= 200 && response.status < 300&&!response.data){
      yield put(fetchProductSpecialFieldSuccess([]))
    }
    yield put(appLoaded())
    // yield put(appLoaded())
    // let p = JSON.parse(JSON.stringify(productsSpecialField));
    // yield put(appLoading())
    // yield put(fetchProductSpecialFieldSuccess(p))
    // yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes (CODE:gpsfr)'))
    yield put(appLoaded())
  }
}

function* createProductRequest(action) {
  const { data,history,cateName,subCateName,unitName } = action.payload
  try {
    yield put(appLoading())
    let reqData = JSON.parse(JSON.stringify(data))
    //setup cover img
    if(reqData.CoverImgURL.trim().length!==0){
      reqData.CoverImg={
        ID: 0,
        ProductID: 0,
        Filename: '',
        OriginaFilename: '',
        Size: '',
        Filetype: '',
        DocumentType: 9,
        FileStream:null,
        UrlPath: reqData.CoverImgURL,
        IsDelete:false
      }
    }else{
      reqData.CoverImg=reqData.CoverImgU[0]||{}
    }
    reqData.AttImg.push(...reqData.AttIMGU) // setup AttImg
    reqData.AttOther.push(...reqData.AttOtherU) //setup AttOther
    delete reqData.CoverImgURL
    delete reqData.CoverImgU
    delete reqData.AttIMGU
    delete reqData.AttOtherU

    //setup Category
    reqData.CategoryName = cateName
    //setup SubCategory
    reqData.SubCategoryName = subCateName
    //setup Unit
    reqData.UnitName = unitName
    
    const response = yield httpPost(`products/create`,reqData)
    if (response.status >= 200 && response.status < 300) {
      yield put(createProductSuccess())
      yield put(toastSuccess('Create Success'))
      history.replace(productDetailPath(response.data))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* editProductRequest(action) {
  const { data,history,cateName,subCateName,unitName } = action.payload
  try {
    yield put(appLoading())
    let reqData = JSON.parse(JSON.stringify(data))
    // setup cover img
    if(reqData.coverImgURL.trim().length>0){
      reqData.coverImg={
        id: 0,
        productId: 0,
        filename: '',
        originaFilename: '',
        size: '',
        filetype: '',
        documentType: 9,
        fileStream:null,
        urlPath: reqData.coverImgURL,
        isDelete:false
      }
    }else{
      if(Array.isArray(reqData.coverImg)){
        let cloneCoverImg = JSON.parse(JSON.stringify(reqData.coverImg))
        reqData.coverImg = cloneCoverImg[0]
      }
    }
    reqData.attImg.push(...reqData.attImgU) // setup AttImg
    reqData.attImgUrl.map((item)=>{
      item.urlPath.trim().length>0&&reqData.attImg.push(item)
    }) 
    reqData.attVdoUrl.map((item)=>{// setup AttImg
      item.urlPath.trim().length>0&&reqData.attVdo.push(item)
    })
    reqData.attOther.push(...reqData.attOtherU) //setup AttOther
    reqData.attOtherUrl.map((item)=>{
      item.urlPath.trim().length>0&&reqData.attOther.push(item)
    })
    
    delete reqData.coverImgURL
    delete reqData.attImgU
    delete reqData.attImgUrl
    delete reqData.attVdoUrl
    delete reqData.attOtherU
    delete reqData.attOtherUrl

    if(cateName){
      //setup Category
      reqData.categoryName = cateName
      //setup SubCategory
      reqData.subCategoryName = subCateName
      //setup Unit
      reqData.unitName = unitName
    }
    const response = yield httpPut(`products/create/56`,reqData)
    if (response.status >= 200 && response.status < 300) {
      yield put(editProductSuccess())
      yield put(toastSuccess('Update Success'))
      yield put(changeEditedProductStatus(true))
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(changeEditedProductStatus(false))
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

function* importProductExcelRequest(action) {
  const { data,history } = action.payload
  try {
    yield put(appLoading())
    let reqData = JSON.parse(JSON.stringify(data))
    reqData.map((item,i)=>{
      item.ProductPrices = item.PricePerUnit
      item.active = item['Public(y,n)'].trim() === 'y'
      item.dimension = item['Dimension ( Size: W * L *H)']
      delete item.PricePerUnit
      delete item['Public(y,n)']
      delete item['Dimension ( Size: W * L *H)']

      item.specialField = ''

      item.coverImg = {}
      item.attImg = []
      item.attVdo = []
      item.attOther = []
      if(item.URLCoverImg){
        item.coverImg = {
          id: 0,
          productId: 0,
          filename: '',
          originaFilename: '',
          size: '',
          filetype: '',
          documentType: 9,
          fileStream:null,
          urlPath: item.URLCoverImg,
          isDelete:false
        }
      }
      delete item.URLCoverImg
      if(item.URLImg){
        item.URLImg.split(';').map((iItem,i)=>{
          if(iItem.length>0){
            item.attImg.push({
              id: 0,
              productId: 0,
              filename: '',
              originaFilename: '',
              size: '',
              filetype: '',
              documentType: 10,
              fileStream:null,
              urlPath: iItem,
              isDelete:false
            })
          }
        })
      }
      delete item.URLImg
      if(item.URLVDO){
        item.URLVDO.split(';').map((iItem,i)=>{
          if(iItem.length>0){
            item.attVdo.push({
              id: 0,
              productId: 0,
              filename: '',
              originaFilename: '',
              size: '',
              filetype: '',
              documentType: 11,
              fileStream:null,
              urlPath: iItem,
              isDelete:false
            })
          }
        })
      }
      delete item.URLVDO
      if(item.URLAttachFile){
        item.URLAttachFile.split(';').map((iItem,i)=>{
          if(iItem.length>0){
            item.attOther.push({
              id: 0,
              productId: 0,
              filename: '',
              originaFilename: '',
              size: '',
              filetype: '',
              documentType: 12,
              fileStream:null,
              urlPath: iItem,
              isDelete:false
            })
          }
        })
      }
      delete item.URLAttachFile
    })

    const response = yield httpPost('products/importProductsExcel',reqData)
    if (response.status >= 200 && response.status < 300) {
      yield put(importProductExcelSuccess())
      yield put(toastSuccess('Import Product Success'))
      history.replace(productPath)
    }
    yield put(appLoaded())
  }
  catch (e) {
    yield put(toastError('Could not connect to server, please try again in a few minutes'))
    yield put(appLoaded())
  }
}

export function* watchProductSaga() {
  yield takeLatest(FETCH_PRODUCTS.REQUEST, fetchProductsRequest)
  yield takeLatest(FETCH_PRODUCT.REQUEST, fetchProductRequest)
  yield takeLatest(FETCH_DATA_LISTVIEW_PROCESS.REQUEST, fetchDataListViewProcessRequest)
  yield takeLatest(FETCH_PRODUCTS_F_EXPORT.REQUEST, fetchProductsForExportRequest)
  yield takeLatest(FETCH_PRODUCT_CATEGORY.REQUEST, fetchProductCategoryRequest)
  yield takeLatest(FETCH_PRODUCT_SUBCATEGORY.REQUEST, fetchProductSubCategoryRequest)
  yield takeLatest(FETCH_PRODUCT_BRANDNAME.REQUEST, fetchProductBrandnameRequest)
  yield takeLatest(FETCH_PRODUCT_UNIT.REQUEST, fetchProductUnitRequest)
  yield takeLatest(FETCH_PRODUCT_SPECIALFIELD.REQUEST, fetchProductSpecialFieldRequest)
  yield takeLatest(PD_SHOW_TABLE, fetchProductOnTableTypeChange)
  yield takeLatest(GET_PRODUCT.REQUEST, getProductRequest)
  yield takeLatest(CREATE_PRODUCT.REQUEST, createProductRequest)
  yield takeLatest(EDIT_PRODUCT.REQUEST, editProductRequest)
  yield takeLatest(IMPORT_PRODUCTS_EXCEL.REQUEST, importProductExcelRequest)
}

export default createReducer(initial, state => ({
  [FETCH_PRODUCTS.REQUEST]: () => ({
    ...state,
    products: [],
    loading: true
  }),
  [FETCH_PRODUCTS.SUCCESS]: (data) => ({
    ...state, 
    products: data.data,  
    loading: false
  }),
  [FETCH_PRODUCT.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCT.SUCCESS]: (data) => ({
    ...state, 
    product: data.data,  
    loading: false
  }),
  [CLEAR_PRODUCTS]: () => ({
    ...state,
    products: [],
  }),
  [SET_PRODUCTS_PAGINATE]: (data) => ({
    ...state,
    paginate: {
      currentPage: data.page,
      recordsPerPage: data.size,
      records: data.totalItem,
      lastPage: data.totalPage
    }
  }),
  [ADD_PRODUCT_WISHLIST]: (data) => {
    if (state.wishlist.some(product => product.id === data.product.id)) {
      return state
    }

    const wishlist = convertProductToWishlist(data.product)

    return {
      ...state,
      wishlist: [...state.wishlist, wishlist]
    }
  },
  [REMOVE_PRODUCT_WISHLIST]: (data) => {
    const wishlist = state.wishlist.filter(product => product.id !== data.productId)

    return {
      ...state,
      wishlist: wishlist
    }
  },


  [FETCH_DATA_LISTVIEW_PROCESS.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_DATA_LISTVIEW_PROCESS.SUCCESS]: (data) => ({
    ...state, 
    // products: data.data.products,
    // productsListImg: data.data.listImg,
    // productsTable: data.data.listTable,
    // productCategory: data.data.cateData.resStr,  
    // filterCategoryOption: data.data.cateData.resStrFilter,
    // productSubCategory: data.data.subCateData.resStr,  
    // filterSubCategoryOption: data.data.subCateData.resStrFilter,
    // productUnit: data.data.unitData,
    // loading: false
  }),
  [FETCH_PRODUCT_CATEGORY.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCT_CATEGORY.SUCCESS]: (data) => {
    return {
      ...state, 
      productCategory: data.data,  
      filterCategoryOption: data.dataFilter,
      loading: false
    }
  },
  [FETCH_PRODUCT_SUBCATEGORY.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCT_SUBCATEGORY.SUCCESS]: (data) => {
    return {
      ...state, 
      productSubCategory: data.data,  
      filterSubCategoryOption: data.dataFilter,
      loading: false
    }
  },
  [FETCH_PRODUCT_UNIT.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCT_UNIT.SUCCESS]: (data) => ({
    ...state, 
    productUnit: data.data,  
    loading: false
  }),
  [FETCH_PRODUCTS_F_EXPORT.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCTS_F_EXPORT.SUCCESS]: (data) => ({
    ...state, 
    productsExport: data.data,  
    loading: false
  }),
  [ADD_PRODUCTS_EXPORT]: (data) => {
    // Add to exportTo
    let pExprotTo = [...state.productsExportTo,data.product]
    // Del from export
    let val = [...state.productsExport]
    let pExport = val.filter(function(value, index, arr){
      return value.id !== data.product.id;
    });
    return {
      ...state, 
      productsExport: pExport,
      productsExportTo: pExprotTo
    }
  },
  [DEL_PRODUCTS_EXPORT]: (data) => {
    // Del product from exportTo
    let val = [...state.productsExportTo,data.product]
    let pExprotTo = val.filter(function(value, index, arr){
      return value.id !== data.product.id;
    });
    // Add product del to export 
    let pExport = [...state.productsExport,data.product]
    return {
      ...state, 
      productsExport: pExport,
      productsExportTo: pExprotTo 
    }
  },
  [CLEAR_PRODUCTS_EXPORT]: (data) => {
    // Del product from exportTo
    let val = []
    return {
      ...state, 
      productsExportTo: val 
    }
  },
  [FETCH_PRODUCTS_LIST_IMG]: (data) => ({
    ...state, 
    productsListImg: data.data 
  }),
  [FETCH_PRODUCTS_TABLE]: (data) => ({
    ...state, 
    productsTable: data.data
  }),
  [CHANGE_PRODUCTS_TO_LIST_IMG]: () => ({
    ...state, 
    products: state.productsListImg
  }),
  [CHANGE_PRODUCTS_TO_TABLE]: () => ({
    ...state, 
    products: state.productsTable
  }),
  [FETCH_PRODUCT_BRANDNAME.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_PRODUCT_BRANDNAME.SUCCESS]: (data) => ({
    ...state, 
    productBrandnameList: data.data,  
    loading: false
  }),
  [GET_PRODUCT.REQUEST]: () => ({
    ...state, 
    loading: true
  }),
  [GET_PRODUCT.SUCCESS]: (data) => ({
    ...state, 
    product: data.data||state.product,  
    loading: false
  }),
  [IMPORT_PRODUCTS_EXCEL.REQUEST]: () => ({
    ...state, 
    loading: true
  }),
  [IMPORT_PRODUCTS_EXCEL.SUCCESS]: () => ({
    ...state, 
    loading: false
  }),
  [DOWNLOAD_PD_SIGNED.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [DOWNLOAD_PD_SIGNED.SUCCESS]: (data) => ({
    ...state,
    filePoSize: data.data !== undefined ? b64toBlob(data.data).size : 0,
    loading: false
  }),
  [PD_CHANGE_FILTER_CATEGORY_ID]: (action) => ({
    ...state,
    filterCategoryID: action.categoryID
  }),
  [PD_CHANGE_FILTER_SUBCATEGORY_ID]: (action) => ({
    ...state,
    filterSubCategoryID: action.subCategoryID
  }),
  [PD_CHANGE_LIST_SIZE]: (action) => ({
    ...state,
    listSize: action.size
  }),
  [PD_SHOW_TABLE]: (action) => ({
    ...state,
    showTable: action.showTable
  }),
  [PD_SEARCH]: (action) => ({
    ...state,
    searchKey: action.searchKey
  }),
  [SET_EXCEL_DATA]: (action) => ({
    ...state, 
    excelData: action.data,  
  }),
  [CHANGE_EDIT_PRODUCT_STATUS]: (action) => ({
    ...state, 
    isEditedProduct: action.isEdit,  
  }),
  [CREATE_PRODUCT.REQUEST]: () => ({
    ...state, 
    loading: true
  }),
  [CREATE_PRODUCT.SUCCESS]: (data) => ({
    ...state, 
    loading: false
  }),
  [EDIT_PRODUCT.REQUEST]: () => ({
    ...state, 
    loading: true
  }),
  [EDIT_PRODUCT.SUCCESS]: (data) => ({
    ...state, 
    loading: false
  }),
  [FETCH_PRODUCT_SPECIALFIELD.REQUEST]: () => ({
    ...state, 
    loading: true
  }),
  [FETCH_PRODUCT_SPECIALFIELD.SUCCESS]: (data) => ({
    ...state, 
    productSpecialField:data.data,
    loading: false
  }),
}))
